module.exports = __webpack_public_path__ + "static/media/39_A.f056a428.png";